import { Card } from "primereact/card";

import "./style.scss";

const CardUI = (props) => (
    <Card {...props} className={`card-ui ${props.className}`}>
        {props.children}
    </Card>
);

export default CardUI;
